import AsyncScriptService from 'services/loader-handler-services/async-script-service';
import utils from 'lib/utils';
export default class AsyncComponentService {
  static async load(components) {
    const componentsArr = [].concat(components); //ensure array
    return AsyncScriptService.load(
      componentsArr.map(component => {
        return {
          http: utils.coursePath(`templates/${component}.js`),
          require: `components/${component}`,
        };
      })
    );
  }
}
